<template>
  <div class="auth-employer-login">
    <form class="auth-employer-login__main"
          @submit.prevent="onSubmit">
      <BasePreloader v-if="pending"/>
      <h1 class="auth-employer-login__title">{{ $tAuthEmployerLogin('title') }}</h1>
      <div class="auth-employer-login__inputs">
        <BaseInput v-model="inputs.email.value"
                   :error="inputs.email.error"
                   :label="$tAuthEmployerLogin('input_email')"
                   type="email"
                   autocomplete="employer-email"
                   class="auth-employer-login__input"/>
        <BaseInput v-model="inputs.password.value"
                   :error="inputs.password.error"
                   :label="$tAuthEmployerLogin('input_password')"
                   type="password"
                   autocomplete="employer-password"
                   class="auth-employer-login__input"/>
        <div class="auth-employer-login__forgot-password-wrap">
          <a href="#" @click.prevent="onForgotPasswordClick">
            {{ $tAuthEmployerLogin('forgot_password') }}
          </a>
        </div>
      </div>
      <BaseAlert :value="overallErrorsMix"
                 class="auth-employer-login__error  _warning"/>
      <button type="submit"
              class="auth-employer-login__btn  base-btn  base-btn--blue">
        {{ $tAuthEmployerLogin('btn_login') }}
      </button>
    </form>
    <div class="auth-employer-login__footer">
      <div class="auth-employer-login__footer-main">
        <div class="auth-employer-login__footer-title">
          {{ $tAuthEmployerLogin('footer_register_title') }}
        </div>
        <router-link-modified :to="{name: 'auth-employer-register', query: {...$route.query}}"
                              class="auth-employer-login__footer-btn  base-btn  base-btn--green">
          {{ $tAuthEmployerLogin('footer_register_btn') }}
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import formMixins from '@/mixins/formMixins'
  import {mapGetters, mapActions} from 'vuex'
  import {PARTNER, EMPLOYER, MODERATOR} from '../../constants/usersTypes';

  export default {
    name: 'AuthEmployerLogin',
    mixins: [formMixins],
    data() {
      return {
        pending: false,

        inputs: {
          email: {
            value: null
          },
          password: {
            value: null
          }
        }
      }
    },
    computed: {
      ...mapGetters('user', [
        'hasVacanciesResponses',
      ]),
    },
    referralCode() {
      return this.$route.query.referal_code || getReferralFromLocalstorage()
    },
    beforeMount() {
      this.applyEmailAndCodeFromParams();
    },
    methods: {
      ...mapActions('user', [
        'loginEmployer'
      ]),
      applyEmailAndCodeFromParams() {
        const { email, code } = this.$route.query;
        if (email && code) {
          this.$vModal.open('employer-forgot-password', {
            defaultEmail: email,
            defaultCode: code,
          });
        }
      },
      onSubmit() {
        this.pending = true
        this.pending = true

        this.resetErrorsMix(this.inputs)
        let sendData = this.createSendDataMix(this.inputs)

        sendData = Object.assign({}, this.$route.query, sendData)

        this.loginEmployer({sendData})
          .then(this.afterLogin)
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      },
      afterLogin({ user }) {
        let redirectTo = {};

        switch (true) {
          case !!this.$route.query.redirect:
            redirectTo = { path: this.$route.query.redirect }; break;
          case user.user_type === PARTNER:
            redirectTo = { name: 'account-partner-resumes-base' }; break;
          case user.user_type === EMPLOYER:
            redirectTo = { name: this.hasVacanciesResponses ? 'account-vacancies-responses' : 'account-vacancies' }; break;
          case user.user_type === MODERATOR:
            redirectTo = { name: 'account-moderator-candidates-resumes' }; break;
          default:
            redirectTo = 'vacancies';
        }

        this.$router.push(redirectTo).catch(() => {});
      },
      onForgotPasswordClick() {
        this.$vModal.open('employer-forgot-password', {
          defaultEmail: this.inputs.email.value,
        });
      },
    },
    created() {
      if (this.referralCode) {
        setReferralToLocalstorage(this.referralCode)
      }
    }
  }

  function setReferralToLocalstorage(code) {
    window.localStorage.setItem('referralCode', code)
  }

  function getReferralFromLocalstorage() {
    return window.localStorage.getItem('referralCode')
  }
</script>

<style lang="less">

</style>
